import _ from 'lodash';
import { GetterTree } from 'vuex';
import { Accessors } from 'vue/types/options';
import { PageModule, RootStore } from '@/main/store/@types/store.d';
import { PageStore, PageStoreProps } from '@/main/store/@types/page';

import { getterAndSetterFromKeyDvm, getterFromKeyDvm, initStore, MappedGetters, Page, mapMutationsDvm, mapActionsDvm } from './page';

function genVuexComputeds<
	StoreState extends PageStore<{}, {}, PageStoreProps>,
	Getters extends GetterTree<StoreState, RootStore>,
>(store: PageModule<StoreState, any, any, any>):
Accessors<StoreState & StoreState['localState'] & MappedGetters<Getters>> {
	const state = store.state();

	return {
		..._.mapValues(state, (keyValue, key: string, object:any) => getterAndSetterFromKeyDvm(key, object)),
		..._.mapValues(state.localState, (keyValue, key: string, object: any) => getterAndSetterFromKeyDvm(`localState.${key}`, object)),
		..._.mapValues(store.getters, (keyValue, key: string, object: any) => getterFromKeyDvm(key, object)),
	} as Accessors<StoreState & StoreState['localState'] & MappedGetters<Getters>>;
}

export function pageFactory<
	TLocalState extends object,
>(name: string, store: PageModule<PageStore<{}, TLocalState, PageStoreProps>, {}, {}, {}>) {
	return Page.extend({
		name,
		computed: {
			...genVuexComputeds(store),
		},
		beforeCreate() {
			initStore(this, name, store);
		},
		methods: {
			...mapActionsDvm(store.actions),
			...mapMutationsDvm(store.mutations),
		},
	});
}
